import * as fromApp from '../reducers/app.reducer';
import * as fromUpload from '../reducers/upload.reducer';
import { createSelector } from '@ngrx/store';
import { EUploadState } from '@app-root-enums';

const selectUpload = (state: fromApp.AppState) => state.upload;

export const selectUploadFiles = createSelector(selectUpload, (state: fromUpload.State) => {
    const files = Object.keys(state.addedFiles).map((key) => state.addedFiles[key]);
    return files.map((file) => {
        const newFile = { ...file };
        if (newFile.tmp_id === state.uploadSidenav.fileActive) {
            newFile.selected = true;
        } else {
            newFile.selected = false;
        }
        return newFile;
    });
});

export const selectUploadGetActiveFile = createSelector(selectUpload, (state: fromUpload.State) => {
    if (state.addedFiles && state.uploadSidenav.fileActive) {
        return state.addedFiles[state.uploadSidenav.fileActive];
    }
    return null;
});

export const selectUploadFileIsActive = createSelector(
    selectUpload,
    (state: fromUpload.State) => !!state.uploadSidenav.fileActive
);

export const selectUploadFolderIsActive = createSelector(
    selectUpload,
    (state: fromUpload.State) => state.uploadSidenav.folderActive
);

export const selectUploadGetReadyFiles = createSelector(selectUpload, (state: fromUpload.State) => {
    const files = Object.keys(state.addedFiles).map((key) => state.addedFiles[key]);
    return files.filter((file) => file.uploadState === EUploadState.READY);
});

export const selectUploadInformationsManagement = createSelector(
    selectUpload,
    (state: fromUpload.State) => state.informations.management
);

export const selectUploadInformationsLegals = createSelector(
    selectUpload,
    (state: fromUpload.State) => state.informations.legals
);

export const selectUploadInformationsLocations = createSelector(
    selectUpload,
    (state: fromUpload.State) => state.informations.locations
);

export const selectUploadInformationsTranslations = createSelector(
    selectUpload,
    (state: fromUpload.State) => state.informations.translations
);

export const selectUploadInformationsManagementLoading = createSelector(
    selectUpload,
    (state: fromUpload.State) => state.informations.managementLoading
);

export const selectUploadInformationsLegalsLoading = createSelector(
    selectUpload,
    (state: fromUpload.State) => state.informations.legalsLoading
);

export const selectUploadInformationsLocationsLoading = createSelector(
    selectUpload,
    (state: fromUpload.State) => state.informations.locationsLoading
);

export const selectUploadInformationsTranslationsLoading = createSelector(
    selectUpload,
    (state: fromUpload.State) => state.informations.translationsLoading
);
